import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/Login'
import AccountRecoveryInitiate from '../pages/AccountRecoveryInitiate'
import AccountRecoveryFinish from '../pages/AccountRecoveryFinish'
import Invite from '../pages/Invite'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    beforeEnter (to, from, next) {
      next('/login')
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/account-recovery',
    name: 'AccountRecoveryInitiate',
    component: AccountRecoveryInitiate
  },
  {
    path: '/account-recovery/:hash',
    name: 'AccountRecoveryFinish',
    component: AccountRecoveryFinish
  },
  {
    path: '/invite/:hash',
    name: 'Invite',
    component: Invite
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
